module.exports = __webpack_public_path__ + "img/alter.596fb62e.svg";